
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ColumnDetailService } from 'tnx-admin-service/columndetail/services';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
    SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';

@Component({
    selector: 'columndetail-form',
    templateUrl: './columndetail-form.component.html',
    styleUrls: ['./columndetail-form.component.scss'],
    providers: [ComponentContextService],
})
export class ColumnDetailFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _columnDetailService: ColumnDetailService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._columnDetailService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'idTableInfo',
                label: 'Id của bảng'
            }),
            new TextControlSchema({
                field: 'ten',
                label: 'Tên cột'
            }),
            new TextControlSchema({
                field: 'tenDayDu',
                label: 'Tên đầy đủ của cột'
            }),
            new TextControlSchema({
                field: 'moTa',
                label: 'Mô tả'
            }),
            new TextControlSchema({
                field: 'kieuDuLieu',
                label: 'Kiểu dữ liệu'
            }),
            new TextControlSchema({
                field: 'code',
                label: 'Mã'
            }),
            new TextControlSchema({
                field: 'currentStateCode',
                label: ''
            })
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

